var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "foundation:social-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6498 4.60498H5.67018C4.85818 4.60498 4.19922 5.24844 4.19922 6.04079V23.0937C4.19922 23.8872 4.85818 24.5315 5.67018 24.5315H22.6498C23.4623 24.5315 24.1257 23.8872 24.1257 23.0937V6.04079C24.1257 5.24844 23.4623 4.60498 22.6498 4.60498ZM10.1091 21.5851H7.15221V12.076H10.1091V21.5851ZM8.63065 10.7758C8.40558 10.7758 8.18273 10.7315 7.97481 10.6453C7.76689 10.5592 7.57799 10.4329 7.41889 10.2737C7.2598 10.1145 7.13364 9.92549 7.04761 9.71752C6.96158 9.50954 6.91738 9.28666 6.91752 9.06159C6.91752 8.60728 7.098 8.17158 7.41925 7.85033C7.74049 7.52908 8.1762 7.34861 8.63051 7.34861C9.08482 7.34861 9.52053 7.52908 9.84177 7.85033C10.163 8.17158 10.3435 8.60728 10.3435 9.06159C10.3435 9.516 10.1631 9.95181 9.8419 10.2732C9.52072 10.5947 9.08505 10.7755 8.63065 10.7758ZM21.1782 21.5851H18.2261V16.9611C18.2261 15.8579 18.2045 14.4395 16.6898 14.4395C15.1516 14.4395 14.9172 15.6409 14.9172 16.8811V21.5854H11.9628V12.076H14.7982V13.3746H14.8386C15.2332 12.6273 16.1975 11.8388 17.6355 11.8388C20.6261 11.8388 21.1785 13.8077 21.1785 16.3691V21.5851H21.1782Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlink);
export default __webpack_public_path__ + "static/media/flink.dfb3e4e978ddad30811a1d86efcb3bbb.svg";
export { ForwardRef as ReactComponent };